import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import $ from "jquery";
import Select from 'react-select';

import { loader_image } from "../_components/Imagepath";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken } from "../Global";
import {MaterialReactTable} from 'material-react-table';
import PropTypes from 'prop-types';

import Swal from 'sweetalert2';
import {

  MenuItem,
} from '@mui/material';
import "react-toastify/dist/ReactToastify.css";
const QualityReports = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  const [permission, setPermission] = useState({});

  const [customerList, setCustomerList] = useState([]);
  const [orderList, setOrderList] = useState([]);

 
  const [formData, setFormData] = useState({
    customer:'',
    order:'',
  });


 


  
  const handleSubmit = (e) => {

    e.preventDefault();

    console.log(formData);
    axios
    .post("/quality-report/listing", formData, {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    }) .then((response) => {
   

      if (response.data.code === 200) {

        setData(response.data.data.reports);
      } 
      else {
         //setBackendErrors(response.data.error);
      }
    })
    .catch((error) => {
      console.log(error);
     // actions.setSubmitting(false);
    });
  
  }
 

    const statusOptions =[
 
      {
          "id": 1,
          "title": "FINALISED",
          "color": "white",
          "bg_color": "GREEN",
      },
      {
        "id": 2,
        "title": "APPROVED",
        "color": "white",
        "bg_color": "BLUE",
    },
    {
        "id": 0,
        "title": "DRAFT",
        "color": "white",
        "bg_color": "RED",
    },
    ];

  useEffect(() => {
       const modulePermission = FindModuleById(447);
  setPermission(modulePermission);
  console.log(modulePermission);

    axios.post("/quality-report/listing",{},{headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
        .then((response) => {
        if (response.data.code === 200) {
          setData(response.data.data.reports);
      
        }
        else  if (response.data.code === 401) {
          window.location.href = "/login";
        }else{
          window.location.href = "/login"; 
        }
      }).catch((error) => {
        console.log(error);
      });
 axios.post("/customers/listing",{},{headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }}).
          then((response) => {
            if (response.data.code === 200) {
              let incoterms = response.data.data.customers;
              let customerListing = incoterms.map((cust, index) => ({
                label: cust.company_name,
                value: cust.id,
                key: `types-${index}`,
              }));
              setCustomerList(customerListing);
            }
      }).catch((error) => {
      console.log(error);
      
    });


        axios.post("/orders-quality-report/listing-shipped-delivered-filter",{},{headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }}).
          then((response) => {
            if (response.data.code === 200) {
              let incoterms = response.data.data.orders;
              let customerListings = incoterms.map((cust, index) => ({
                label: cust.po_number,
                value: cust.id,
                key: `types-${index}`,
              }));
              console.log(customerListings);
              setOrderList(customerListings);
            }
      }).catch((error) => {
      console.log(error);
      
    });
  }, []);

  const deleteItem = (item) => {
    Swal.fire({
      title: 'Do you really want to delete this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/quality-report/delete/${item}`, {
              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
            })
            .then((response) => {
              console.log(response);
              if (response.data.code === 200) {
                Swal.fire(
                  'Deleted!',
                  'Your Record has been deleted.',
                  'success'
                );
                axios.post("/quality-report/listing",{},{headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
                  .then((response) => {
                  if (response.data.code === 200) {
                    setData(response.data.data.reports);
                
                  }
                  else  if (response.data.code === 401) {
                    window.location.href = "/login";
                  }else{
                    window.location.href = "/login"; 
                  }
                }).catch((error) => {
                  console.log(error);
              });
              }
            })
            .catch((error) => {
              console.log(error);
            });
      }
    });
  }


  const editItem = (item)=>{
    window.location.href = "/quality-reports-editpallet/"+item;
  }


  const FichedePalletePDF = async (report) => {

    console.log(report);
    $("#loader-image1").removeClass('loader-hide');
    $("#loader-image1").addClass('loader-show');
    axios.get(`/quality-report/pdf/${report.id}`, {
      responseType: 'blob',
    headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }
  }).then(response => {
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);

      const containerNumber = report.container_number?.toString().replace(/[^a-zA-Z0-9_-]/g, '') || 'Container';
      const customer = report.customer?.toString().replace(/[^a-zA-Z0-9 ]/g, '') || 'Customer';
      const poNumber = report.order_detail?.po_number?.toString().replace(/[^a-zA-Z0-9_-]/g, '') || 'PO';
      const fileName = `${containerNumber} Quality Report ${customer} - ${poNumber}.pdf`;
      link.download = fileName;
      link.click();
      $("#loader-image1").addClass('loader-hide');
        $("#loader-image1").removeClass('loader-show');
  })
  .catch(error => {
      console.error('Error downloading PDF:', error);
  });

  };
  
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  const PONumberCell = ({ row }) => {
    return (
      <a href={`/quality-reports-view/${row.original.id}`} className="">
        {row.original.order_name}
      </a>
    );
  };
  
      const changeOrderStatus = (user_id, status,type) =>{
  
      Swal.fire({
        title: 'Do you want change Status?',
        //text: 'This action cannot be undone.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'green',
        cancelButtonColor: '#d33',
        confirmButtonText: 'CONFIRM',
        customClass: "swal-orders"
      }).then((result) => {
        if (result.isConfirmed) {
          axios.get(`/quality-report/change-status/${user_id}/${status}`, {headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
              .then((response) => {
                console.log(response);
                if (response.data.code === 200) {
                  $("#status-"+type+"-"+user_id).text(response.data.data.report_status.title);
                  $("#status-"+type+"-"+user_id).css('background-color',response.data.data.report_status.bg_color);
                  $("#status-"+type+"-"+user_id).css('color',response.data.data.report_status.color);
                  axios.post("/quality-report/listing",{},{headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
                  .then((response) => {
                  if (response.data.code === 200) {
                    setData(response.data.data.reports);
                
                  }
                  else  if (response.data.code === 401) {
                    window.location.href = "/login";
                  }else{
                    window.location.href = "/login"; 
                  }
                }).catch((error) => {
                  console.log(error);
              });

                  Swal.fire(
                    'Changed!',
                    'Quality Report Status has been changed Successfully.',
                    'success'
                  );
                
                }
              })
              .catch((error) => {
                console.log(error);
              }); 
             }
      });
    }

    const OrderStatusDropdownCell = ({ row, permission, statusOptions, changeOrderStatus }) => {
        if (permission && permission.update === 1) {
          return (
            <div className="btn-group custom-table-btn-group">
              <button
                type="button"
                className="btn btn-block dropdown-toggle me-1"
                id={`status-all-${row.original.id}`}
                style={{ backgroundColor: row.original.report_status?.bg_color, color: row.original.report_status?.color }}
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                {row.original.report_status?.title || ''}
              </button>
              <div className="dropdown-menu">
                {statusOptions &&
                  statusOptions.map((shipp) => (
                    <button
                      key={shipp.id}
                      className="dropdown-item btn btn-block"
                      style={{ backgroundColor: shipp.bg_color, color: shipp.color }}
                      onClick={() => changeOrderStatus(row.original.id, shipp.id, 'all')}
                    >
                      {shipp.title}
                    </button>
                  ))}
              </div>
            </div>
          );
        }
    
    
      return (
        <button
          type="button"
          className="btn btn-block me-1"
          id={`status-all-${row.original.id}`}
          style={{ backgroundColor: row.original.report_status?.bg_color, color: row.original.report_status?.color }}
        >
          {row.original.report_status?.title || ''}
        </button>
      );
    };
    OrderStatusDropdownCell.propTypes = {
      row: PropTypes.shape({
        original: PropTypes.shape({
          id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
          report_status: PropTypes.shape({
            title: PropTypes.string,
            bg_color: PropTypes.string,
            color: PropTypes.string,
          }),
        }).isRequired,
      }).isRequired,
      permission: PropTypes.shape({
        update: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      }),
      statusOptions: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
          title: PropTypes.string.isRequired,
          bg_color: PropTypes.string,
          color: PropTypes.string,
        })
      ).isRequired,
      changeOrderStatus: PropTypes.func.isRequired,
    };
    
  PONumberCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        order_name: PropTypes.string.isRequired,
        
      }).isRequired,
    }).isRequired,
  };
  
  const columns =
  [
      {
        header: 'Order PO Number',
        accessorFn: (row) => `${(row.order_detail)?row.order_detail.po_number:""}`,
        Cell: PONumberCell, // ✅ Use the separate component    
      },
   
    {
      accessorKey: 'customer', //normal accessorKey
      header: 'Customer',
    },
    {
      accessorKey: 'sender', //normal accessorKey
      header: 'Sender',
    },
    {
      accessorKey: 'loading_type', //normal accessorKey
      header: 'Loading Type',
    },
  
    {
      accessorKey: 'container_number', //normal accessorKey
      header: 'Container Number',
    },
  
    {
      accessorKey: 'product', //normal accessorKey
      header: 'Product',
    },
  
    {
      accessorKey: 'ref', //normal accessorKey
      header: 'REF',
    },
    {
      header: 'Report Status',
      accessorFn: (row) => row.report_status?.title || '',
      Cell: (props) => (
        <OrderStatusDropdownCell
          {...props}
          permission={permission}
          statusOptions={statusOptions}
          changeOrderStatus={changeOrderStatus}
        />
      ),
    },
    {
      accessorKey: 'date', //normal accessorKey
      header: 'Date',
    },
  
   
    {
      header: 'Created By',
      accessorFn: (row) => `${(row.createdby)?row.createdby.first_name+ ' '+ row.createdby.last_name:""} `,
    },
    {
      header: 'Updated By',
      accessorFn: (row) => `${(row.updatedby)?row.updatedby.first_name+ ' '+ row.updatedby.last_name:""} `,
    },
   ];

  const handleSelectChangeCustomer = (selectedOption) => {
    setFormData({ ...formData, customer: selectedOption ? selectedOption.value : null });
  };
  const handleSelectChangeOrder = (selectedOption) => {
    setFormData({ ...formData, order: selectedOption ? selectedOption.value : null });
  };

  const getOrderByCustomer = (customer)=>{
    console.log(customer);
    axios.get(`/order-by-customer/${customer.value}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
       
           let incoterms = response.data.data.orders;
              let customerListings = incoterms.map((cust, index) => ({
                label: cust.po_number,
                value: cust.id,
                key: `types-${index}`,
              }));
              console.log(customerListings);
              setOrderList(customerListings);

        }
      })
      .catch((error) => {
        console.log(error);
      });


  }
  
 
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar /> 
         {/* <ToastContainer /> */}

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title">Quality Reports</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item active">
                    Quality Reports
                    </li>
                  </ul>
                </div>
                <div className="col-auto">
                  {permission && permission.add === 1 && (
                      <Link
                      to="/quality-reports-add"
                      className="btn btn-primary me-1"
                    >
                      <i className="fas fa-plus"></i>
                    </Link>
                      )} 
                  
                 
                </div>
              </div>
           
           
            </div>

            <div id="" className="card">
              <div className="card-body p-10">
                <form onSubmit={handleSubmit}>
                <div className="row">
               
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Select Customer:</label>
                    
                      <Select
                                                 
                            options={customerList}
                            name="customer"
                            value={customerList.find(option => option.value === formData.customer) || null} 
                           // onChange={(selectedOption) => handleSelectChangeCustomer(selectedOption); handleSelectChangeCustomer(selectedOption)}
                            onChange={(e) => {
                                  handleSelectChangeCustomer(e);
                                  getOrderByCustomer(e);


                                }}
                          />
                    </div>
                  </div>


                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Select Order:</label>
                    
                      <Select
                                                 
                            options={orderList}
                            name="customer"
                            value={orderList.find(option => option.value === formData.order) || null} 
                            onChange={(selectedOption) => handleSelectChangeOrder(selectedOption)}
                          />
                    </div>
                  </div>
                
                
                
                  <div className="col-md-2">
                    <div className="pt-4 mt-2">
                      <button type="submit" className="btn btn-primary">
                        Filter
                      </button>
                      &nbsp;&nbsp;
                      <a href="/quality-reports" className="btn btn-primary me-1"><i className="fa fa-times"></i></a>

                    </div>
                  </div>
                </div>
                </form>
                
              </div>
            </div>
            
                        <div className="row">
                          <div className="col-sm-12">
                          {permission && permission.list === 1 && ( 
                            <div className="card card-table">
                              <div className="card-body">
                              <div className="table-responsive">
            
                                <MaterialReactTable columns={columns} data={data} 
                                    enableColumnOrdering
                                    enablePinning
                                    enableRowActions
                                    renderRowActionMenuItems={({ row }) => [
                                      permission?.update === 1 && (
                                        <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                          Edit
                                        </MenuItem>
                                      ),
                                        permission?.list === 1 && (
                                      <MenuItem key="view" onClick={() => FichedePalletePDF(row.original)}>
                                      Download <img  id={`loader-image1`} className="loader-image loader-hide" src={loader_image}/> 
                                    </MenuItem>
                                    ),
                                      permission?.delete === 1 && (
                                        <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                          Delete
                                        </MenuItem>
                                      ),
                                    ]}
                                  />
                                </div>
                                
                              
                              </div>
                            </div>
                          )}
                          </div>
                        </div>
              
        
          </div>
        </div>
      </div>
    </>
  );
};
export default QualityReports;
